import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Mail, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { BrandMark } from "@/components/BrandMark";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("lc_admin_token")) navigate("/admin/dashboard", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("lc_admin_token", data.token);
      localStorage.setItem("lc_admin_email", data.email);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao entrar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[color:var(--brand-graphite)] px-4">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-[0_30px_80px_rgba(0,0,0,0.4)]"
      >
        <div className="flex flex-col items-center">
          <BrandMark size={54} />
          <h1 className="mt-4 font-serif text-2xl font-semibold text-[color:var(--brand-graphite)]">Painel LC Produção</h1>
          <p className="mt-1 text-sm text-[color:var(--brand-muted)]">Acesso restrito à equipe.</p>
        </div>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <Label>E-mail</Label>
            <div className="relative mt-1.5">
              <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[color:var(--brand-muted)]" />
              <Input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 pl-9" placeholder="seu@email.com" />
            </div>
          </div>
          <div>
            <Label>Senha</Label>
            <div className="relative mt-1.5">
              <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[color:var(--brand-muted)]" />
              <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 pl-9" placeholder="••••••••" />
            </div>
          </div>
          <Button data-testid="admin-login-button" type="submit" disabled={loading} className="h-11 w-full bg-[color:var(--brand-marsala)] text-white hover:bg-[color:var(--brand-marsala-hover)]">
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null} Entrar
          </Button>
        </form>
      </motion.div>
    </div>
  );
}
